import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  ApiPaginationResult,
  ApiResult,
} from '../../shared/models/api-result.model';
import { SelectOption } from '../../shared/models/dropdowm.model';
import {
  CreateLateFeePolicy,
  LateFeeType,
  UpdateLateFeePolicy,
} from '../models/late-fee-policy.model';

@Injectable({
  providedIn: 'root',
})
export class LateFeePolicyService {
  private http = inject(HttpClient);

  apiBaseUrl = environment.apiBaseUrl;

  getAll(pageNumber: number, pageSize: number, name?: string) {
    let params = '';

    if (name) params += `&name=${encodeURIComponent(name)}`;

    return this.http.get<ApiPaginationResult>(
      this.apiBaseUrl +
        `/api/v1/late-fee-policies?pageNumber=${pageNumber}&pageSize=${pageSize}${params}`
    );
  }

  getById(id: string) {
    return this.http.get<ApiResult>(
      this.apiBaseUrl + '/api/v1/late-fee-policies/' + id
    );
  }

  getAllDropdown() {
    return this.http.get<ApiResult>(
      this.apiBaseUrl + '/api/v1/late-fee-policies/dropdown'
    );
  }

  create(data: CreateLateFeePolicy) {
    return this.http.post<ApiResult>(
      this.apiBaseUrl + '/api/v1/late-fee-policies',
      data
    );
  }

  update(id: string, data: UpdateLateFeePolicy) {
    return this.http.put<ApiResult>(
      this.apiBaseUrl + '/api/v1/late-fee-policies/' + id,
      data
    );
  }

  updateStatus(id: string, isActive: boolean) {
    return this.http.patch<ApiResult>(
      this.apiBaseUrl + `/api/v1/late-fee-policies/${id}/status`,
      { isActive }
    );
  }

  getLateFeeTypeOptions(): SelectOption[] {
    return [
      { label: 'Percentual', value: LateFeeType.Percentage },
      { label: 'Valor fixo', value: LateFeeType.FixedAmount },
    ];
  }
}
